module.exports = __webpack_public_path__ + "static/media/weChatCode.50eeed6d.png";